export default {
	site: "Site",
	role: "Role",
	submitTime: "Submit Time",
	exportTime: "Export Time",
	exportStatus: "Export Status",
	exported: "Exported",
	notExported: "Not Exported"
};
